/* Aubelys · sections aub-chl-* : galerie, pastilles coloris, offres (coloris par châle), ajout au panier (tiroir du thème). */
(function () {
  'use strict';
  if (window.aubChlInit) return;
  window.aubChlInit = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');

  /* galerie : miniatures, flèches, et saut vers une photo donnée (coloris) */
  var goMedia = function () {};
  $$('[data-aubl-gal]').forEach(function (g) {
    var tr = $('.aubl-gal__track', g), slides = $$('.aubl-gal__slide', g), th = $$('[data-aubl-thumbs] button', g);
    if (!tr) return;
    var idx = function () { return Math.round(tr.scrollLeft / tr.clientWidth); };
    var go = function (i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      tr.scrollTo({ left: i * tr.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    th.forEach(function (b, i) { b.onclick = function () { go(i); }; });
    $$('.aubl-arrow', g).forEach(function (b) { b.onclick = function () { go(idx() + (+b.getAttribute('data-dir'))); }; });
    tr.addEventListener('scroll', function () {
      var k = idx();
      th.forEach(function (b, i) { b.setAttribute('aria-current', String(i === k)); });
      if (th[k]) th[k].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }, { passive: true });
    goMedia = function (id) { slides.forEach(function (s, i) { if (s.getAttribute('data-media') === String(id)) go(i); }); };
  });

  $$('[data-aubl-buy]').forEach(function (col) {
    var variants = [];
    try { variants = (JSON.parse($('[data-aubl-variants]', col).textContent) || {}).variants || []; } catch (e) {}
    var byColor = function (c) { return variants.filter(function (v) { return v.option1 === c; })[0]; };
    var offers = $$('.aubl-offer', col), btn = $('[data-aubl-atc]', col), msg = $('[data-aubl-msg]', col), cartEl = $('cart-drawer');
    var colorName = $('[data-aubl-color]', col), formId = $('#aubl-form input[name="id"]');
    var current = function () { var r = $('.aubl-sw__i input:checked', col); return r ? r.value : (variants[0] && variants[0].option1); };

    /* pastilles : libellé, photo du coloris, variante du formulaire */
    $$('.aubl-sw__i input', col).forEach(function (r) {
      r.addEventListener('change', function () {
        var v = byColor(r.value);
        if (colorName) colorName.textContent = r.value;
        if (v && formId) formId.value = v.id;
        if (v && v.featured_media) goMedia(v.featured_media.id);
      });
    });

    /* menus de coloris des lots : la photo du coloris choisi s'affiche dans la galerie */
    $$('[data-aubl-row] select', col).forEach(function (s) {
      s.addEventListener('change', function () { var v = byColor(s.value); if (v && v.featured_media) goMedia(v.featured_media.id); });
    });
    var sync = function () { offers.forEach(function (o) { o.classList.toggle('is-on', $('input', o).checked); }); };
    offers.forEach(function (o) { $('input', o).addEventListener('change', sync); });
    sync();
    if (!btn) return;

    btn.addEventListener('click', function () {
      var on = offers.filter(function (o) { return o.classList.contains('is-on'); })[0];
      if (!on) return;
      var picks = $$('[data-aubl-row] select', on).map(function (s) { return s.value; });
      if (!picks.length) picks = Array(+on.getAttribute('data-qty') || 1).fill(current());
      var counts = {}, order = [], missing = false;
      picks.forEach(function (c) {
        var v = byColor(c);
        if (!v || !v.available) { missing = true; return; }
        if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
        counts[v.id]++;
      });
      if (missing) { if (msg) msg.textContent = 'Ce coloris n’est plus disponible.'; return; }
      var body = { items: order.map(function (id) { return { id: id, quantity: counts[id] }; }) };
      if (cartEl) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      btn.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (o) {
          btn.disabled = false;
          if (!o.ok) { if (msg) msg.textContent = o.j.description || 'Impossible d’ajouter le châle au panier.'; return; }
          if (msg) msg.textContent = '';
          if (cartEl && typeof cartEl.renderContents === 'function') {
            cartEl.renderContents(o.j); cartEl.classList.remove('is-empty');
            var inn = cartEl.querySelector('.drawer__inner'); if (inn) inn.classList.remove('is-empty');
            if (typeof cartEl.open === 'function' && !cartEl.classList.contains('active')) cartEl.open();
          } else window.location = root + 'cart';
        })
        .catch(function () { btn.disabled = false; if (msg) msg.textContent = 'Une erreur est survenue, réessayez.'; });
    });
  });

  /* barre d'achat fixe : visible une fois les offres et le bouton principal dépassés (sortis par le haut) ; son bouton fait défiler jusqu'aux offres */
  (function () {
    var bar = $('[data-aubl-sticky]'), offers = $('.aubl-offers'), atc = $('[data-aubl-atc]');
    if (!bar || !offers || !('IntersectionObserver' in window)) return;
    var btn = $('[data-aubl-sticky-btn]', bar), seen = new Map();
    /* cible = titre des offres (« Offre d'Automne ») s'il précède le bloc, sinon le bloc ; position calculée sous l'en-tête fixe du thème,
       puis recalée une fois le défilement fini (images chargées entre-temps) ; pas de focus (sur iPhone il fait sauter la page) */
    var target = function () { var d = offers.previousElementSibling; return d && d.classList.contains('aubl-divider') ? d : offers; };
    var headerH = function () { var h = $('sticky-header, .shopify-section-header-sticky, .section-header'); var r = h && h.getBoundingClientRect(); return r && r.bottom > 0 && r.top <= 0 ? r.bottom : (r && getComputedStyle(h).position === 'sticky' ? r.height : 0); };
    var y = function () { return Math.max(0, target().getBoundingClientRect().top + window.pageYOffset - headerH() - 12); };
    btn.addEventListener('click', function () {
      var smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: y(), behavior: smooth ? 'smooth' : 'auto' });
      setTimeout(function () { var d = y() - window.pageYOffset; if (Math.abs(d) > 4) window.scrollTo({ top: y(), behavior: 'auto' }); }, smooth ? 900 : 50);
    });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
      var show = !Array.from(seen.values()).some(Boolean) && offers.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-on', show); bar.setAttribute('aria-hidden', String(!show)); btn.tabIndex = show ? 0 : -1;
    });
    io.observe(offers); if (atc) io.observe(atc);
  })();

  /* avis : « Charger plus » affiche la page suivante ; un clic sur une photo l'agrandit */
  $$('[data-aubl-reviews]').forEach(function (rv) {
    var per = +rv.getAttribute('data-per') || 10, more = $('[data-aubl-more]', rv), dlg = $('[data-aubl-zoom-dlg]', rv);
    /* les avis au-delà de la 1re page attendent dans un <template> (hors DOM) : chaque clic en ajoute une page */
    var rest = $('template[data-aubl-rest]', rv), list = $('.aubl-rv__list', rv);
    if (more && rest && list) more.addEventListener('click', function () {
      var items = [].slice.call(rest.content.children, 0, per);
      items.forEach(function (it) { list.appendChild(it); });
      if (!rest.content.children.length) more.parentNode.hidden = true;
    });
    if (dlg && dlg.showModal) rv.addEventListener('click', function (e) {
      var z = e.target.closest('[data-aubl-zoom]');
      if (z) { $('img', dlg).src = z.getAttribute('data-aubl-zoom'); dlg.showModal(); }
      else if (e.target.closest('[data-aubl-zoom-close]') || e.target === dlg) dlg.close();
    });
  });
})();

